import React from "react";

import { Reorder, useDragControls } from "framer-motion";

export default function ListItem({
  item,
  itemIdName,
  ItemComponent,
  onRelease,
  onMouseDown,
  onMouseUp,
  isActiveItem,
  itemHasDragTrigger,
  disabled,
  ...props
}) {
  const controls = useDragControls();

  // Start fix to force Reorder to work with mobile touch events
  // See this issue related to framer-motion: https://github.com/framer/motion/issues/1597
  // and the example I stole this fix from: https://codesandbox.io/s/framer-motion-5-drag-to-reorder-lists-with-drag-handle-forked-fix-7bypke?file=/src/Item.tsx:396-888
  const iRef = React.useRef();

  React.useEffect(
    function makeDNDWorkOnMobile() {
      const touchHandler = (e) => e.preventDefault();

      const iTag = iRef.current;

      if (iTag) {
        iTag.addEventListener("touchstart", touchHandler, { passive: false });

        return () => {
          iTag.removeEventListener("touchstart", touchHandler, {
            passive: false,
          });
        };
      }
    },
    [iRef]
  );
  // End fix for mobile touch event allowing drag and drop.

  return (
    <Reorder.Item
      value={item}
      id={item[itemIdName]?.toString()}
      onPointerDown={() =>
        !itemHasDragTrigger ? onMouseDown(item[itemIdName]) : null
      }
      onPointerUp={() =>
        itemHasDragTrigger ? onMouseUp(item[itemIdName]) : null
      }
      onDragEnd={(e, info) => {
        onRelease();
      }}
      dragListener={!itemHasDragTrigger}
      dragControls={controls}
      style={{
        position: "relative",
      }}
    >
      <ItemComponent
        itemRef={iRef}
        item={item}
        isActiveItem={isActiveItem}
        onPointerDown={(e) => {
          controls.start(e);
          onMouseDown(item[itemIdName]);
        }}
        disabled={disabled}
        itemIdName={itemIdName}
        {...props}
        {...(item?.props || {})}
      />
    </Reorder.Item>
  );
}
